import { environment as base } from './environment.base';

export const environment = {
    ...base,
    "apiEndpoint": 'https://api-demo1-devere-core-com-d-0.dvep.net/api',
    "environmentName": 'Demo 1 Environment'  
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
